import Decimal from "decimal.js";

Decimal.set({ rounding: Decimal.ROUND_HALF_UP });

/**
 * Multiply two monetary values and round to `dp` decimal places.
 * Avoids IEEE-754 drift (e.g. 0.1 * 0.2 ≠ 0.02 in plain JS).
 */
export function multiplyMoney(a, b, dp = 2) {
	return new Decimal(a ?? 0)
		.times(new Decimal(b ?? 0))
		.toDecimalPlaces(dp)
		.toNumber();
}

/**
 * Add two monetary values and round to `dp` decimal places.
 */
export function addMoney(a, b, dp = 2) {
	return new Decimal(a ?? 0)
		.plus(new Decimal(b ?? 0))
		.toDecimalPlaces(dp)
		.toNumber();
}

/**
 * Sum an array of monetary values with Decimal accumulation.
 */
export function sumMoney(values, dp = 2) {
	return values
		.reduce((acc, v) => acc.plus(new Decimal(v ?? 0)), new Decimal(0))
		.toDecimalPlaces(dp)
		.toNumber();
}

/**
 * Apply a VAT/tax rate percentage to a base amount.
 * Returns taxAmount (not gross).
 */
export function calcTax(base, vatPercent, dp = 2) {
	return new Decimal(base ?? 0)
		.times(new Decimal(vatPercent ?? 0))
		.dividedBy(100)
		.toDecimalPlaces(dp)
		.toNumber();
}

/**
 * Round a monetary value to `dp` decimal places.
 */
export function roundMoney(value, dp = 2) {
	return new Decimal(value ?? 0).toDecimalPlaces(dp).toNumber();
}
